import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

const initialState={
    invoiceList:[],
    selectedInvoice: null,
    status:"idle",
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    error:''
}

export const fetchInvoice=createAsyncThunk('invoice/fetchInvoice', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/invoice/getInvoice',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchInvoiceById=createAsyncThunk('invoice/fetchInvoiceById', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/invoice/getInvoiceById/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const createInvoice=createAsyncThunk('invoice/createInvoice', async (invoice)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/invoice/createInvoice',
        {
            method:'POST',
            body: JSON.stringify(invoice),
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            }
        }
    )
    return response.json()
})

export const updateInvoice=createAsyncThunk('invoice/updateInvoice', async ({invoice,cid})=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/invoice/updateInvoice/${cid}`,
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(invoice)
        }
    )
    return response.json()
})

export const deleteInvoice=createAsyncThunk('invoice/deleteInvoice', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/invoice/deleteInvoice/${id}`,
        {
            method: 'DELETE',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const invoiceSlice=createSlice({
    name:'invoice',
    initialState,
    reducers: {
        changeRegisterStatus: (state) => {
            state.registerstatus = 'failure';
        },
        changeEditStatus: (state) => {
            state.editstatus = 'failure';
        },
        changeDeleteStatus: (state) => {
            state.deletestatus = 'failure';
        },
    },
    extraReducers:(builder)=>{
        builder
        .addCase(fetchInvoice.pending, (state)=>{
            state.status='loading'
        })
        .addCase(fetchInvoice.fulfilled, (state, action)=>{
            state.status='succeeded'
            state.invoiceList=action.payload
        })
        .addCase(fetchInvoice.rejected, (state, action)=>{
            state.status='failed'
            state.error=action.error.message
        })
        .addCase(fetchInvoiceById.pending, (state)=>{
            state.status='loading'
        })
        .addCase(fetchInvoiceById.fulfilled, (state, action)=>{
            state.status='succeeded'
            state.selectedInvoice=action.payload
        })
        .addCase(fetchInvoiceById.rejected, (state, action)=>{
            state.status='failed'
            state.error=action.error.message
        })
            .addCase(createInvoice.pending, (state)=>{
                state.registerstatus='loading'
            })
            .addCase(createInvoice.fulfilled, (state, action)=>{
                state.registerstatus='succeeded'
                state.invoiceList.push(action.payload)
            })
            .addCase(createInvoice.rejected, (state, action)=>{
                state.registerstatus='failed'
                state.error=action.error.message
            })
             .addCase(updateInvoice.pending, (state)=>{
                state.editstatus='loading'
            })
            .addCase(updateInvoice.fulfilled, (state, action)=>{
                state.editstatus='succeeded'
                const index = state.invoiceList.findIndex(invoice => invoice.id === action.payload.id);
                if (index !== -1) {
                    state.invoiceList[index] = action.payload;
                }
            })
            .addCase(updateInvoice.rejected, (state, action)=>{
                state.editstatus='failed'
                state.error=action.error.message
            })
             .addCase(deleteInvoice.pending, (state)=>{
                state.deletestatus='loading'
            })
            .addCase(deleteInvoice.fulfilled, (state, action)=>{
                state.deletestatus='succeeded'
                state.invoiceList = state.invoiceList.filter(invoice => invoice.id !== action.payload.id);
            })
            .addCase(deleteInvoice.rejected, (state, action)=>{
                state.deletestatus='failed'
                state.error=action.error.message
            })
    }
})

export default invoiceSlice.reducer;
